import ErrorPageImage from '@assets/images/Maintenance.png'
import MediaImage from '@components/MediaImage'
import { colors } from '@globals/themes/defaultTheme'
import ConstrainedWidthLayout from '@layouts/ConstrainedWidthLayout'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PageKudosTitleImage from '@shared/PageKudosTitleImage'
import { ButtonStyles, StackStyles } from '@shared/routing/RoutingStyles'
import { T } from '@transifex/react'
import { ReactNode } from 'react'

type ErrorPageLayoutProps = {
  title: ReactNode
  onClick: () => void
  description?: ReactNode
  buttonText?: ReactNode
  errorImage?: string
}
const ErrorPageLayout: React.FC<ErrorPageLayoutProps> = ({
  title,
  onClick,
  description,
  buttonText = <T _str="Reload page" />,
  errorImage = ErrorPageImage,
}) => {
  return (
    <ConstrainedWidthLayout>
      <Stack useFlexGap spacing={3} sx={StackStyles}>
        <PageKudosTitleImage />
        <MediaImage
          imgSrc={errorImage}
          maxWidth={320}
          maxHeight={320}
          backgroundColor="transparent"
        />
        <Stack maxWidth={600} alignItems="center" p={2} mt={-4}>
          <Stack justifyContent="center" alignItems="center">
            <Typography variant="h2" mt={{ xs: 0 }}>
              {title}
            </Typography>
            {description && (
              <Typography textAlign="center" color={colors.grayMedium}>
                {description}
              </Typography>
            )}
          </Stack>
          <Button
            id="btnGenericErrorRefresh"
            variant="contained"
            onClick={onClick}
            sx={ButtonStyles}>
            {buttonText}
          </Button>
        </Stack>
      </Stack>
    </ConstrainedWidthLayout>
  )
}

export default ErrorPageLayout
